export enum ChatbotName {
  ENDOZONE_CONSULTATION_SUPPORT = 'Endozone consultation support',
}

export interface SendChatMessageRequest {
  conversationId: string;
  message: string;
  chatbotName: ChatbotName;
}
